/**
 * AEPEmptyState Component
 * Displays empty state when no AEP evaluations exist
 */
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { FileSpreadsheet, Plus } from 'lucide-react';

const AEPEmptyState = ({ onCreateClick }) => {
  return (
    <Card className="p-12" data-testid="aep-empty-state">
      <CardContent className="flex flex-col items-center justify-center text-center p-0">
        <FileSpreadsheet className="w-16 h-16 text-slate-300 mb-4" />
        <h3 className="text-lg font-semibold text-slate-700 mb-2">
          Nenhuma avaliação ergonômica cadastrada
        </h3>
        <p className="text-slate-500 mb-4">
          Comece criando sua primeira AEP (Análise Ergonômica Preliminar) para identificar riscos ergonômicos.
        </p>
        <Button 
          onClick={onCreateClick}
          className="bg-[#0d9488] hover:bg-[#0b7d73]"
        >
          <Plus className="w-4 h-4 mr-2" />
          Nova Avaliação AEP
        </Button>
      </CardContent>
    </Card>
  );
};

export default AEPEmptyState;
